import styled from 'styled-components'

export const ShimmerContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 56px);
  padding: 16px 24px;
  overflow: hidden;
`
